import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import { AppLayout } from "./components/layout/AppLayout";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PatientsPage from "./pages/PatientsPage";
import PatientDetailPage from "./pages/PatientDetailPage";
import PatientFormPage from "./pages/PatientFormPage";
import FormsPage from "./pages/FormsPage";
import FormBuilderPage from "./pages/FormBuilderPage";
import FormSubmitPage from "./pages/FormSubmitPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import EventQuotePage from "./pages/EventQuotePage";
import EventQuoteDetailPage from "./pages/EventQuoteDetailPage";
import ClinicalNotesPage from "./pages/ClinicalNotesPage";
import InvoicesPage from "./pages/InvoicesPage";
import EventQuotesManagePage from "./pages/EventQuotesManagePage";
import SchedulingPage from "./pages/SchedulingPage";
import PatientSummariesPage from "./pages/PatientSummariesPage";
import DataExportPage from "./pages/DataExportPage";
import PublicHomePage from "./pages/PublicHomePage";
import PatientRequestPage from "./pages/PatientRequestPage";
import PatientRequestsPage from "./pages/PatientRequestsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicHomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/event-quote" element={<EventQuotePage />} />
          <Route path="/patient-request" element={<PatientRequestPage />} />
          
          {/* Protected Routes */}
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            
            {/* Patients */}
            <Route path="patients" element={<PatientsPage />} />
            <Route path="patients/new" element={<PatientFormPage />} />
            <Route path="patients/:id" element={<PatientDetailPage />} />
            <Route path="patients/:id/edit" element={<PatientFormPage />} />
            <Route path="patients/:patientId/clinical-notes" element={<ClinicalNotesPage />} />
            <Route path="patients/:patientId/invoices" element={<InvoicesPage />} />
            
            {/* Forms */}
            <Route path="forms" element={<FormsPage />} />
            <Route path="forms/builder" element={<FormBuilderPage />} />
            <Route path="forms/builder/:id" element={<FormBuilderPage />} />
            <Route path="forms/submit/:templateId" element={<FormSubmitPage />} />
            
            {/* Scheduling */}
            <Route path="scheduling" element={<SchedulingPage />} />
            
            {/* Patient Summaries */}
            <Route path="patient-summaries" element={<PatientSummariesPage />} />
            
            {/* Data Export */}
            <Route path="data-export" element={<DataExportPage />} />
            
            {/* Invoices */}
            <Route path="invoices" element={<InvoicesPage />} />
            
            {/* Event Quotes Management */}
            <Route path="event-quotes" element={<EventQuotesManagePage />} />
            <Route path="event-quotes/:id" element={<EventQuoteDetailPage />} />
            
            {/* Patient Requests */}
            <Route path="patient-requests" element={<PatientRequestsPage />} />
            
            {/* Users */}
            <Route path="users" element={<UsersPage />} />
            
            {/* Settings */}
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
